import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, InputNumber, Select, Typography } from "antd";

const ScenarioSelection = ({
  wallWidth,
  setWallWidth,
  wallHeight,
  setWallHeight,
  unit,
  setUnit,
  setColumn,
  setRow,
  selectedModelData,
  column,
  row,
}) => {
  return (
    <>
      <div>
        <Typography
          style={{
            color: "#FFF",
            fontSize: 12,
            marginTop: 12,
            marginBottom: 5,
          }}
        >
          Unit
        </Typography>
        <Select
          placeholder="Select Unit"
          style={{ width: "100%", height: "100%" }}
          value={unit}
          onChange={(value) => {
            if (value === "feet") {
              setWallWidth(10);
              setWallHeight(8);
              setColumn(1);
              setRow(1);
            } else {
              setWallWidth(3);
              setWallHeight(2);
              setColumn(1);
              setRow(1);
            }
            setUnit(value);
          }}
        >
          <Select.Option value="meter">Metre</Select.Option>
          <Select.Option value="feet">Feet</Select.Option>
        </Select>

        <Typography
          style={{
            color: "#FFF",
            fontSize: 12,
            marginTop: 12,
            marginBottom: 5,
          }}
        >
          Wall Width
        </Typography>
        <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
          <Button
            icon={<MinusOutlined style={{ color: "#fff" }} />}
            style={{
              width: 35,
              display: "flex",
              alignItems: "center",
              color: "#fff",
            }}
            onClick={() => {
              if (wallWidth > 0) {
                setWallWidth(wallWidth - 1);
                // setColumn(1); //COMMENTED OUT FOR NOW
                // setRow(1); //COMMENTED OUT FOR NOW
              }
            }}
            disabled={
              wallWidth === 1 ||
              (selectedModelData !== null &&
                (unit === "meter"
                  ? (column + 1) *
                      selectedModelData.panelDimensions.metric[0].width >
                    wallWidth * 1000
                  : (column + 1) *
                      selectedModelData.panelDimensions.imperial[0].width >
                    wallWidth * 12))
            }
            variant="solid"
            color="default"
          />
          <Button
            icon={<PlusOutlined style={{ color: "#fff" }} />}
            style={{
              width: 35,
              display: "flex",
              alignItems: "center",
              color: "#fff",
            }}
            onClick={() => {
              setWallWidth(wallWidth + 1);
              // setColumn(1); //COMMENTED OUT FOR NOW
              // setRow(1); //COMMENTED OUT FOR NOW
            }}
            variant="solid"
            color="default"
            disabled={unit === "meter" ? wallWidth === 18 : wallWidth === 60}
          />
          <InputNumber
            style={{ width: "calc(100% - 70px)", marginLeft: 5 }}
            min={1}
            max={9999999999}
            value={wallWidth}
            onChange={(value) => setWallWidth(value)}
            suffix={unit === "meter" ? "m" : "ft"}
          />
        </div>
        {selectedModelData !== null &&
          (unit === "meter"
            ? (column + 1) * selectedModelData.panelDimensions.metric[0].width >
              wallWidth * 1000
            : (column + 1) *
                selectedModelData.panelDimensions.imperial[0].width >
              wallWidth * 12) && (
            <div>
              <Typography
                style={{ color: "#9191c5", fontSize: 12, marginTop: 10 }}
              >
                Can't decrease because of the setted column(s)
              </Typography>
            </div>
          )}

        <Typography
          style={{
            color: "#FFF",
            fontSize: 12,
            marginTop: 12,
            marginBottom: 5,
          }}
        >
          Wall Height
        </Typography>
        <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
          <Button
            icon={<MinusOutlined style={{ color: "#fff" }} />}
            style={{
              width: 35,
              display: "flex",
              alignItems: "center",
              color: "#fff",
            }}
            onClick={() => {
              if (wallHeight > 0) {
                setWallHeight(wallHeight - 1);
                // setColumn(1); //COMMENTED OUT FOR NOW
                // setRow(1); //COMMENTED OUT FOR NOW
              }
            }}
            disabled={
              wallHeight === 1 ||
              (selectedModelData !== null &&
                (unit === "meter"
                  ? (row + 1) *
                      selectedModelData.panelDimensions.metric[0].height >
                    wallHeight * 1000
                  : (row + 1) *
                      selectedModelData.panelDimensions.imperial[0].height >
                    wallHeight * 12))
            }
            variant="solid"
            color="default"
          />

          <Button
            icon={<PlusOutlined style={{ color: "#fff" }} />}
            style={{
              width: 35,
              display: "flex",
              alignItems: "center",
              color: "#fff",
            }}
            onClick={() => {
              setWallHeight(wallHeight + 1);
              // setColumn(1); //COMMENTED OUT FOR NOW
              // setRow(1); //COMMENTED OUT FOR NOW
            }}
            variant="solid"
            color="default"
            disabled={unit === "meter" ? wallHeight === 8 : wallHeight === 26}
          />

          <InputNumber
            style={{ width: "calc(100% - 70px)", marginLeft: 5 }}
            defaultValue={0}
            min={1}
            max={9999999999}
            value={wallHeight}
            onChange={(value) => setWallHeight(value)}
            suffix={unit === "meter" ? "m" : "ft"}
          />
        </div>
        {selectedModelData !== null &&
          (unit === "meter"
            ? (row + 1) * selectedModelData.panelDimensions.metric[0].height >
              wallHeight * 1000
            : (row + 1) * selectedModelData.panelDimensions.imperial[0].height >
              wallHeight * 12) && (
            <div>
              <Typography
                style={{ color: "#9191c5", fontSize: 12, marginTop: 10 }}
              >
                Can't decrease because of the setted row(s)
              </Typography>
            </div>
          )}
      </div>
    </>
  );
};

export default ScenarioSelection;
